import gql from 'graphql-tag';

export const GET_AGENT_BRANCHES_FOR_VALUATIONS = gql`
    query valuationAgentsForProperty(
        $propertyId: Int!
        $transactionType: TransactionType!
        $v2Seed: String!
        $routeNewValuationBranchLogic: Boolean
    ) {
        valuationBranches(
            propertyId: $propertyId
            transactionType: $transactionType
            v2Seed: $v2Seed
            routeNewValuationBranchLogic: $routeNewValuationBranchLogic
        ) {
            area
            branchDisplayName
            branchId
            logo
            outcode
            selected
            averageRentPrice
            averageSalePrice
            numberOfSaleListings
            numberOfRentListings
            address
            postcode
        }
    }
`;
